import { SocialTab,SocialTabType } from '@/models/Social/Profile/social-tab';
import { SocialDialog, SocialThread, SocialThreadType } from '@/models/Social/social-dialog';
import { SocialLikes, SocialLikesType  } from '@/models/Social/social-likes';
import request from '@/Utilities/httpRequest';

export class SocialTabQuestions extends SocialTab {
    protected _dialogs: Array<SocialDialog> = new Array<SocialDialog>();
    protected _nextpage: number|null = 1;
    protected _isLoading: boolean = false;
    protected _kstrings?: object;

    public set dialogs(dialogs: Array<SocialDialog>){
        this._dialogs = dialogs;
    }

    public get dialogs(): Array<SocialDialog> {
        if(this._isLoading){
            let dialog = new SocialDialog(new SocialThread('',''), '');
            dialog.loading = true;
            return [...this._dialogs,dialog,dialog,dialog];
        }
        return this._dialogs;
    }

    protected _getParams(): object|undefined {
        if(this._nextpage === null){
            return undefined;
        }
        return {...this._params,...{page:this._nextpage}};
    }

    public getData():Array<SocialDialog>{
        return this._dialogs;
    }

    public hasContent(): boolean{
        return this._dialogs.length > 0;
    }

    protected _data(value: any){
        let elements = value.elements ?? [];
        let kstrings = value.kstrings ?? null;
        if(kstrings && !this._kstrings){
            this._kstrings = kstrings;
        }
        if(elements){
            elements.forEach((e: any) => {this._addSocialDialog(e)});
            this._nextpage = value.nextpage ?? null;
        }else{
            this._nextpage = null;
        }
    }

    protected _addSocialDialog(value: any){
        let id   = value?.id ?? null;
        let text = value?.text ?? null;
        if(id && text){
            let thread = new SocialThread(id, text);
            thread.author = value?.author ?? undefined;
            thread.type = value?.type ?? undefined;
            thread.translation = value?.translation ?? undefined;
            thread.hasReply = value?.hasReply ?? true;
            if(value?.isQuestion ?? false){
                thread.type = SocialThreadType.Question;
            }
            if(value?.isPending ?? false){
                thread.type = SocialThreadType.PendingComment;
            }
            let dialog = new SocialDialog(thread, (value?.postId ?? ''));
            if(value.likes ?? null){
                dialog.likes = new SocialLikes(value.likes.num ?? 0, value.likes.liked ?? false);
                dialog.likes.id = id ?? undefined;
                dialog.likes.type = SocialLikesType.COMMENT;
            }
            if(this._url && this._params){
                dialog.setMore(this._url,this._params);
            }
            if(this._kstrings){
                dialog.kStrings = this._kstrings;
            }
            dialog.allowReply = value?.allowReply ?? false;
            this._dialogs.push(dialog);
        }
    }

    public async nextPage() {
        let params: any = this._getParams();
        if(this._isLoading){
            return false;
        }
        if(this._url && this._nextpage && params){
            this._isLoading = true;
            let { data } = await request.post(this._url,params,false);
            this._data(data);
            this._isLoading = false;
        }
    }

    public reload() {
        this.dialogs = [];
        this._nextpage = 1;
        this.nextPage();
    }

    public get type(): SocialTabType{
        return SocialTabType.dialogs;
    }
}